var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "detialInfo" },
    [
      _c(
        "el-collapse",
        {
          model: {
            value: _vm.activeNames,
            callback: function ($$v) {
              _vm.activeNames = $$v
            },
            expression: "activeNames",
          },
        },
        [
          _c(
            "el-collapse-item",
            {
              attrs: {
                title: _vm.$t("collectionCenter.waybillSRMessage"),
                name: "1",
              },
            },
            [
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "el-descriptions",
                    {
                      attrs: { colon: false, column: 3, direction: "vertical" },
                    },
                    [
                      _c(
                        "el-descriptions-item",
                        [
                          _c("template", { slot: "label" }, [
                            _c(
                              "div",
                              { staticStyle: { "font-weight": "normal" } },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      padding: "5px",
                                      background: "#00a121",
                                      color: "#fff",
                                      "border-radius": "5px",
                                      "margin-right": "8px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("collectionCenter.ji"))
                                    ),
                                  ]
                                ),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("collectionCenter.addresser"))
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                          _c("encryption-field", {
                            attrs: {
                              "encrypted-value": _vm.tableInfomation.senderName,
                              label: _vm.$t("collectionCenter.addresser"),
                              "field-name": "senderName",
                            },
                          }),
                        ],
                        2
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("newOrder.senderPhone") } },
                        [
                          _c("encryption-field", {
                            attrs: {
                              "encrypted-value":
                                _vm.tableInfomation.senderMobile,
                              label: _vm.$t("newOrder.senderPhone"),
                              "field-name": "senderMobile",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("newOrder.SenderPhone") } },
                        [
                          _c("encryption-field", {
                            attrs: {
                              "encrypted-value":
                                _vm.tableInfomation.senderPhone,
                              label: _vm.$t("newOrder.SenderPhone"),
                              "field-name": "senderPhone",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("newOrder.SenderCompany") } },
                        [
                          _c("encryption-field", {
                            attrs: {
                              "encrypted-value":
                                _vm.tableInfomation.senderCompany,
                              label: _vm.$t("newOrder.SenderCompany"),
                              "field-name": "senderCompany",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("newOrder.SenderCPF") } },
                        [
                          _c("encryption-field", {
                            attrs: {
                              "encrypted-value": _vm.tableInfomation.senderTax,
                              label: _vm.$t("newOrder.SenderCPF"),
                              "field-name": "senderTax",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("newOrder.SenderEmail") } },
                        [
                          _c("encryption-field", {
                            attrs: {
                              "encrypted-value": _vm.tableInfomation.senderMail,
                              label: _vm.$t("newOrder.SenderEmail"),
                              "field-name": "senderMail",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-descriptions-item",
                        {
                          attrs: {
                            label: _vm.$t("orderCenterCont.SenderStreet"),
                          },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.tableInfomation.senderStreet || "--")
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("newOrder.SenderNumber") } },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.tableInfomation.senderHouseNumber || "--"
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("newOrder.SenderDistrict") } },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.tableInfomation.senderArea || "--")
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("newOrder.SenderCity") } },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.tableInfomation.senderCity || "--")
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("newOrder.SenderState") } },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.tableInfomation.senderState || "--")
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "GlobalSetObj.NationalRegistrationNumber"
                            ),
                          },
                        },
                        [
                          _c("encryption-field", {
                            attrs: {
                              "encrypted-value":
                                _vm.tableInfomation.senderIeNumber,
                              label: _vm.$t(
                                "GlobalSetObj.NationalRegistrationNumber"
                              ),
                              "field-name": "senderIeNumber",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-descriptions-item",
                        {
                          attrs: {
                            label: _vm.$t("GlobalSetObj.sendderComplement"),
                          },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.tableInfomation.senderComplement || "--"
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("newOrder.SenderZipCode") } },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.tableInfomation.senderZipcode || "--")
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("newOrder.SendingAddress") } },
                        [
                          _c("encryption-field", {
                            attrs: {
                              "encrypted-value":
                                _vm.tableInfomation.senderAddress,
                              label: _vm.$t("newOrder.SendingAddress"),
                              "field-name": "senderAddress",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                {
                  staticClass: "box-card",
                  staticStyle: { "margin-top": "10px" },
                },
                [
                  _c(
                    "el-descriptions",
                    {
                      attrs: { colon: false, column: 3, direction: "vertical" },
                    },
                    [
                      _c(
                        "el-descriptions-item",
                        [
                          _c("template", { slot: "label" }, [
                            _c(
                              "div",
                              { staticStyle: { "font-weight": "normal" } },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      padding: "5px",
                                      background: "#00a121",
                                      color: "#fff",
                                      "border-radius": "5px",
                                      "margin-right": "8px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("collectionCenter.shou"))
                                    ),
                                  ]
                                ),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("collectionCenter.recipientS")
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                          _c("encryption-field", {
                            attrs: {
                              "encrypted-value":
                                _vm.tableInfomation.receiveName,
                              label: _vm.$t("collectionCenter.recipientS"),
                              "field-name": "receiveName",
                            },
                          }),
                        ],
                        2
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("newOrder.Recipientphone") } },
                        [
                          _c("encryption-field", {
                            attrs: {
                              "encrypted-value":
                                _vm.tableInfomation.receiveMobile,
                              label: _vm.$t("newOrder.Recipientphone"),
                              "field-name": "receiveMobile",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-descriptions-item",
                        {
                          attrs: {
                            label: _vm.$t("newOrder.Recipientphonenumber"),
                          },
                        },
                        [
                          _c("encryption-field", {
                            attrs: {
                              "encrypted-value":
                                _vm.tableInfomation.receivePhone,
                              label: _vm.$t("newOrder.Recipientphonenumber"),
                              "field-name": "receivePhone",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-descriptions-item",
                        {
                          attrs: { label: _vm.$t("newOrder.RecipientCompany") },
                        },
                        [
                          _c("encryption-field", {
                            attrs: {
                              "encrypted-value":
                                _vm.tableInfomation.receiveCompany,
                              label: _vm.$t("newOrder.RecipientCompany"),
                              "field-name": "receiveCompany",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("newOrder.RecipientCPF") } },
                        [
                          _c("encryption-field", {
                            attrs: {
                              "encrypted-value": _vm.tableInfomation.receiveTax,
                              label: _vm.$t("newOrder.RecipientCPF"),
                              "field-name": "receiveTax",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("newOrder.RecipientEmail") } },
                        [
                          _c("encryption-field", {
                            attrs: {
                              "encrypted-value":
                                _vm.tableInfomation.receiveMail,
                              label: _vm.$t("newOrder.RecipientEmail"),
                              "field-name": "receiveMail",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("orderCenterCont.Street") } },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.tableInfomation.receiveStreet || "--")
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("newOrder.doorNumber") } },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.tableInfomation.receiveHouseNumber || "--"
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        {
                          attrs: {
                            label: _vm.$t("newOrder.RecipientDistrict"),
                          },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.tableInfomation.receiveArea || "--")
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("newOrder.RecipientCity") } },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.tableInfomation.receiveCity || "--")
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("newOrder.RecipientState") } },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.tableInfomation.receiveState || "--")
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "GlobalSetObj.NationalRegistrationNumber"
                            ),
                          },
                        },
                        [
                          _c("encryption-field", {
                            attrs: {
                              "encrypted-value":
                                _vm.tableInfomation.receiveIeNumber,
                              label: _vm.$t(
                                "GlobalSetObj.NationalRegistrationNumber"
                              ),
                              "field-name": "receiveIeNumber",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-descriptions-item",
                        {
                          attrs: {
                            label: _vm.$t("GlobalSetObj.recipientComplement"),
                          },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.tableInfomation.receiveComplement || "--"
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        {
                          attrs: { label: _vm.$t("newOrder.RecipientZipCode") },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.tableInfomation.receiveZipcode || "--")
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        {
                          attrs: { label: _vm.$t("newOrder.ReceivingAddress") },
                        },
                        [
                          _c("encryption-field", {
                            attrs: {
                              "encrypted-value":
                                _vm.tableInfomation.receiveAddress,
                              label: _vm.$t("newOrder.ReceivingAddress"),
                              "field-name": "receiveAddress",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-collapse-item",
            { attrs: { title: _vm.$t("navbar.willNumberInfo"), name: "2" } },
            [
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "el-descriptions",
                    {
                      attrs: { colon: false, column: 3, direction: "vertical" },
                    },
                    [
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("navbar.anjunOrderNumber") } },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.tableInfomation.orderNumber || "--")
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("navbar.totalNumber") } },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.tableInfomation.waybillCount || "--")
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("newOrder.createTime") } },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.tableInfomation.createTime || "--")
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("newOrder.CustomerName") } },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.tableInfomation.customerName || "--")
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("newOrder.orderNumber") } },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.tableInfomation.customerNumber || "--")
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("newOrder.TypeService") } },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.expressTypeName[
                                  _vm.tableInfomation.expressType
                                ] || "--"
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("newOrder.CollectionType") } },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.collectTypeName[
                                  _vm.tableInfomation.collectType
                                ] || "--"
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("placeOrder.goodType") } },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.cargoTypeName[
                                  _vm.tableInfomation.cargoType
                                ] || "--"
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        {
                          attrs: {
                            label: _vm.$t("navbar.totalCreateOrderWeight"),
                          },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.tableInfomation.totalCreateOrderWeight ||
                                  "--"
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        {
                          attrs: {
                            label: _vm.$t("navbar.totalParcelDeclaredVolume"),
                          },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.tableInfomation.totalParcelDeclaredVolume ||
                                  "--"
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("navbar.transportWeight") } },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.tableInfomation.totalTransportWeight || "--"
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("navbar.transportVolume") } },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.tableInfomation.totalTransportVolume || "--"
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "compensationManagement.PaymentMethod"
                            ),
                          },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.tableInfomation.paymentTypeName || "--"
                              )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-collapse-item",
            {
              attrs: {
                title: _vm.$t("collectionCenter.lanshouMsg"),
                name: "6",
              },
            },
            [
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "el-descriptions",
                    {
                      attrs: { colon: false, column: 3, direction: "vertical" },
                    },
                    [
                      _c(
                        "el-descriptions-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "collectionCenter.collectionSignature"
                            ),
                          },
                        },
                        [
                          _vm.tableInfomation.orderCollectInfo.finishSignUrl
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    color: "#00A551",
                                    display: "inline-block",
                                  },
                                },
                                [
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        title: _vm.$t(
                                          "collectionCenter.collectionSignature"
                                        ),
                                        placement: "right-end",
                                        "popper-class": "popover_class",
                                        trigger: "hover",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                cursor: "default",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "collectionCenter.View"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("span", {
                                            staticClass: "el-icon-view",
                                            staticStyle: {
                                              "margin-left": "10px",
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "img_box_class",
                                          staticStyle: {
                                            "max-width": "410px",
                                            "min-width": "200px",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-image",
                                            {
                                              staticClass: "imgClass",
                                              attrs: {
                                                src: _vm.tableInfomation
                                                  .orderCollectInfo
                                                  .finishSignUrl,
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "image-slot",
                                                  staticStyle: {
                                                    display: "flex",
                                                    "align-items": "center",
                                                    "justify-content": "center",
                                                    height: "100%",
                                                  },
                                                  attrs: { slot: "error" },
                                                  slot: "error",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-picture-outline",
                                                    staticStyle: {
                                                      "font-size": "240px",
                                                      color: "#c0c4cc",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _c("div", [_vm._v("--")]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.collectionPhoto"),
                          },
                        },
                        [
                          _vm.tableInfomation.orderCollectInfo.imgUrl &&
                          _vm.tableInfomation.orderCollectInfo.imgUrl.length > 0
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    color: "#00A551",
                                    display: "inline-block",
                                  },
                                },
                                [
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        title: _vm.$t(
                                          "collectionCenter.collectionPhoto"
                                        ),
                                        placement: "right-end",
                                        "popper-class": "popover_class",
                                        trigger: "hover",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                cursor: "default",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "collectionCenter.View"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("span", {
                                            staticClass: "el-icon-view",
                                            staticStyle: {
                                              "margin-left": "10px",
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "img_box_class",
                                          staticStyle: {
                                            "max-width": "700px",
                                            "max-height": "650px",
                                          },
                                        },
                                        _vm._l(
                                          _vm.tableInfomation.orderCollectInfo
                                            .imgUrl,
                                          function (item, idx) {
                                            return _c(
                                              "el-image",
                                              {
                                                key: idx,
                                                staticClass: "imgClass2",
                                                attrs: { src: item },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "image-slot",
                                                    staticStyle: {
                                                      display: "flex",
                                                      "align-items": "center",
                                                      "justify-content":
                                                        "center",
                                                      height: "100%",
                                                    },
                                                    attrs: { slot: "error" },
                                                    slot: "error",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-picture-outline",
                                                      staticStyle: {
                                                        "font-size": "240px",
                                                        color: "#c0c4cc",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _c("div", [_vm._v("--")]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.collector"),
                          },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.tableInfomation.orderCollectInfo
                                  .scanUserName || "--"
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        {
                          attrs: { label: _vm.$t("collectionCenter.lanshouT") },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.tableInfomation.orderCollectInfo.scanTime ||
                                  "--"
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "collectionCenter.licensePlateNumber"
                            ),
                          },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.tableInfomation.orderCollectInfo
                                  .vehicleNumber || "--"
                              )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-collapse-item",
            { attrs: { title: _vm.$t("navbar.childrenTableData"), name: "3" } },
            [
              _c("template", { slot: "title" }, [
                _c("div", { staticStyle: { width: "100%", display: "flex" } }, [
                  _c("div", { staticStyle: { flex: "1" } }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("navbar.childrenTableData")) + " "
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        flex: "1",
                        "text-align": "right",
                        "margin-right": "20px",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.downloadAllTags($event)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("navbar.DownloadAllTags")))]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.childrenTableData,
                        height: _vm.isHeight,
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("newOrder.SerialNumber"),
                          align: "center",
                          type: "index",
                          width: "70",
                        },
                      }),
                      _vm._l(_vm.tableHeaderList1, function (item) {
                        return [
                          _c("el-table-column", {
                            key: item.id,
                            attrs: {
                              align: item.center,
                              label: item.label,
                              "min-width": item.cloWidth,
                              prop: item.prop,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row[item.prop]
                                              ? "" + scope.row[item.prop]
                                              : "--"
                                          )
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ]
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("orderCenterCont.FaceSheet"),
                          align: "center",
                          fixed: "right",
                          width: "120",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", { staticClass: "QuestionMark" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: scope.row.labelUrl,
                                        target: "_blank",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("GlobalSetObj.see")))]
                                  ),
                                ]),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadSheep(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("GlobalSetObj.download")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-collapse-item",
            {
              attrs: {
                title: _vm.$t("collectionCenter.cnsignmentInformation"),
                name: "4",
              },
            },
            [
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.childrenTableData1,
                        height: _vm.isHeight1,
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("newOrder.SerialNumber"),
                          align: "center",
                          type: "index",
                          width: "70",
                        },
                      }),
                      _vm._l(_vm.tableHeaderList2, function (item) {
                        return [
                          _c("el-table-column", {
                            key: item.id,
                            attrs: {
                              align: item.center,
                              label: item.label,
                              "min-width": item.cloWidth,
                              prop: item.prop,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      item.prop === "declared"
                                        ? _c("div", [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "orderCenterCont.packageWorth"
                                                  )
                                                ) +
                                                  ": " +
                                                  _vm._s(
                                                    scope.row.declaredValue ||
                                                      "- -"
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "orderCenterCont.DeclaredWeight"
                                                  )
                                                ) +
                                                  ": " +
                                                  _vm._s(
                                                    scope.row.declaredWeight ||
                                                      "- -"
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ])
                                        : item.prop === "objSize"
                                        ? _c("div", [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("navbar.objLength")
                                                ) +
                                                  ":" +
                                                  _vm._s(
                                                    scope.row.objLength || "- -"
                                                  )
                                              ),
                                            ]),
                                          ])
                                        : _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row[item.prop]
                                                  ? "" + scope.row[item.prop]
                                                  : "--"
                                              )
                                            ),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-collapse-item",
            {
              attrs: {
                title: _vm.$t("orderCenterCont.InvoiceInformation"),
                name: "5",
              },
            },
            [
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.childrenTableData2,
                        height: _vm.isHeight2,
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("newOrder.SerialNumber"),
                          align: "center",
                          type: "index",
                          width: "70",
                        },
                      }),
                      _vm._l(_vm.tableHeaderList3, function (item) {
                        return [
                          _c("el-table-column", {
                            key: item.id,
                            attrs: {
                              align: item.center,
                              label: item.label,
                              "min-width": item.cloWidth,
                              prop: item.prop,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row[item.prop]
                                              ? "" + scope.row[item.prop]
                                              : "--"
                                          )
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }